import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Intl } from '@src/_metronic/i18n/I18nProvider';

import { setToken } from '@app/helpers/User';

import toast from '@app/partials/content/Toast';

function Identifier() {
    const dispatch = useDispatch();

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());

        if (!params?.token || !params?.refresh || !params?.cache) {
            toast({
                variant: 'danger',
                message: Intl.formatMessage({ id: 'AUTOUSER.LOGIN.ERROR' }),
            });
            return;
        }

        setToken(dispatch, {
            token: params.token,
            refresh_token: params.refresh,
            'x-autouser-cache': params.cache,
        });
        window.location.href = window.location.origin;
    }, [dispatch]);

    return null;
}

export default Identifier;
